import StyledButton from 'components/Elements/StyledButton'
import { Formik } from 'formik'
import { useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import * as Yup from 'yup'
import { RegistrationContainer } from './style'

import '../../../../../../node_modules/@syncfusion/ej2-base/styles/material.css'
import '../../../../../../node_modules/@syncfusion/ej2-popups/styles/material.css'
import '../../../../../../node_modules/@syncfusion/ej2-react-calendars/styles/material.css'

import { L10n, loadCldr } from '@syncfusion/ej2-base'
import StyledLoader from 'components/Elements/StyledLoader'
import axiosClient from 'services/axios-client'
import { EMAIL_RX } from 'services/constants'

/* eslint-disable */
loadCldr(
  require('cldr-data/main/de/ca-gregorian.json'),
  require('cldr-data/main/de/numbers.json'),
  require('cldr-data/main/de/timeZoneNames.json'),
  require('cldr-data/supplemental/numberingSystems.json'),
)
/* eslint-enable */
L10n.load({
  de: {
    calendar: { today: 'heute' },
  },
})

function Registration() {
  const infoForm = useRef(null)
  const { t } = useTranslation()

  const options = [
    { value: 'en', label: 'English' },
    { value: 'de', label: 'Deutsch' },
  ]

  const [bookLanguage, setBookLanguage] = useState(null)
  const [langError, setLangError] = useState(null)
  const [submitError, setSubmitError] = useState(null)
  const onChangeBookLanguage = (option) => {
    setBookLanguage(option.value)
    setLangError(null)
  }
  const selectedLanguage = options.filter((lo) => lo.value === bookLanguage)
    ? options.filter((lo) => lo.value === bookLanguage)[0]
    : null

  const ValidationSchemaAll = Yup.object().shape({
    purchaserFirstName: Yup.string().required(t('required_field')),
    purchaserLastName: Yup.string().required(t('required_field')),
    purchaserEmail: Yup.string()
      .required(t('required_field'))
      .matches(EMAIL_RX, t('email_must_valid')),
    purchaserEmailVerify: Yup.string()
      .required(t('required_field'))
      .oneOf([Yup.ref('purchaserEmail'), null], t('email_not_match')),
    description: Yup.string().test('len', t('max_length_500'), (val) => {
      if (val) {
        return val.length < 500
      } else {
        return true
      }
    }),
  })

  const [loading, setLoading] = useState(false)

  const checkout = ({
    purchaserEmail,
    purchaserEmailVerify,
    purchaserFirstName,
    purchaserLastName,
  }) => {
    setLoading(true)

    const info = {
      price_id:
        process.env[
          `REACT_APP_STRIPE_PRICE_ID_AUTHOR_${bookLanguage}`.toUpperCase()
        ],
      allow_promotion_codes: true,
      success_url: `${process.env.REACT_APP_BASE_URL}/checkout-complete`,
      cancel_url: `${process.env.REACT_APP_BASE_URL}/get-started`,
      purchase_info: {
        description: '',
        email: '',
        emailVerify: '',
        firstName: '',
        lastName: '',
        lang: bookLanguage,
        purchaserEmail,
        purchaserEmailVerify,
        purchaserFirstName,
        purchaserLastName,
        startDate: new Date(),
        type: 'author',
        amount: 9900,
        currency: 'EUR',
        package: {
          name: 'Basic',
          product_id: 1,
          product_type_id: 1,
          price: 99,
          cost: 49,
        },
      },
    }

    axiosClient.post('/purchase/checkout', info).then((res) => {
      if (res.ok) {
        window.location.href = res.data
      } else {
        setSubmitError(res.data?.message)
      }

      setLoading(false)
    })
  }

  const FormField = ({
    placeholder = '',
    name = '',
    value = '',
    onChange = () => {},
    isInvalid,
    error,
    disabled,
  }) => {
    return (
      <Row className="mt-2">
        <Col md={12}>
          <Form.Control
            type="text"
            name={name}
            value={value}
            onChange={onChange}
            isInvalid={isInvalid}
            disabled={disabled}
            placeholder={placeholder}
          />
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        </Col>
      </Row>
    )
  }

  if (loading) <StyledLoader />

  return (
    <RegistrationContainer>
      <Formik
        validationSchema={ValidationSchemaAll}
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={{
          purchaserFirstName: '',
          purchaserLastName: '',
          purchaserEmail: '',
          purchaserEmailVerify: '',
        }}
        onSubmit={(values, { setSubmitting }) => {
          if (!bookLanguage) {
            setLangError(t('required_field'))
            setSubmitting(false)
          } else {
            checkout(values)
          }
        }}
      >
        {({ handleSubmit, handleChange, values, errors }) => (
          <Form ref={infoForm} onSubmit={handleSubmit}>
            {/* ISSUE IS RB! Formik itself is fine */}
            <Row>
              <Form.Group
                as={Col}
                md="6"
                controlId="validationFormik01"
                className="pr-md-3"
              >
                <Row className="mt-2">
                  <Col md={5}>
                    <Form.Control
                      type="text"
                      name="purchaserFirstName"
                      value={values.purchaserFirstName}
                      onChange={handleChange}
                      isInvalid={!!errors.purchaserFirstName}
                      placeholder={t('your_first_name')}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.purchaserFirstName}
                    </Form.Control.Feedback>
                  </Col>

                  <Col md={7} className="mt-2 mt-md-0">
                    <Form.Control
                      type="text"
                      name="purchaserLastName"
                      value={values.purchaserLastName}
                      onChange={handleChange}
                      isInvalid={!!errors.purchaserLastName}
                      placeholder={t('your_last_name')}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.purchaserLastName}
                    </Form.Control.Feedback>
                  </Col>
                </Row>
                <FormField
                  name="purchaserEmail"
                  label={t('email')}
                  placeholder={t('your_email_address')}
                  value={values.purchaserEmail}
                  onChange={handleChange}
                  error={errors.purchaserEmail}
                  isInvalid={!!errors.purchaserEmail}
                />
                <FormField
                  name="purchaserEmailVerify"
                  label={t('email')}
                  placeholder={t('your_email_verify')}
                  value={values.purchaserEmailVerify}
                  onChange={handleChange}
                  error={errors.purchaserEmailVerify}
                  isInvalid={!!errors.purchaserEmailVerify}
                />
                <Row className="mt-2">
                  <Col md={12}>
                    <Select
                      className={
                        langError
                          ? 'select-language-error'
                          : 'select-language-normal'
                      }
                      name="language"
                      value={selectedLanguage}
                      onChange={onChangeBookLanguage}
                      options={options}
                      placeholder={t('select_preferred_language_book')}
                    />
                    {langError && (
                      <div className="error-message">{langError}</div>
                    )}
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group
                as={Col}
                md="6"
                controlId="validationFormik05"
                className="pl-md-3"
              >
                <h4 className="form-item-title">{t('what_happens_next')}</h4>
                <Row className="mt-3">
                  <Col md={12}>
                    <h4 className="date-description">
                      <ul>
                        <li>
                          {t(
                            'started_steps_registration_form2_date_description1',
                          )}
                        </li>
                        <li>
                          {t(
                            'started_steps_registration_form2_date_description2',
                          )}
                        </li>
                        <li>
                          {t(
                            'started_steps_registration_form2_date_description3',
                          )}
                        </li>
                      </ul>
                    </h4>
                  </Col>
                </Row>
                <StyledButton
                  type="submit"
                  className="btn-blue mt-3"
                  title={t('continue_to_checkout')}
                />

                <Form.Control.Feedback type="error">
                  {submitError}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
          </Form>
        )}
      </Formik>
    </RegistrationContainer>
  )
}

export default Registration
